import { checkEnrichedName } from 'bto-models/utils/string';
/**
 * Model for Match Outcomes
 */
export default class MatchesOutcomeModel {
  /**
   * class constructor method
   * @param data
   */
  constructor(data, rawData) {
    /**
     * is outcome active
     * @type {Boolean}
     */
    this.active = data.a;
    /**
     * Outcome ID
     * @type {number}
     */
    this.id = data.id;
    /**
     * Outcome Name
     * @type {string}
     */
    this.name = data.n;
    /**
     * Enriched outcome name
     * @type {string}
     */
    this.enrichedOutcomeName = checkEnrichedName(data.eon, rawData.ht, rawData.at, data.sbv);
    /**
     * Odd value
     * @type {number}
     */
    // this.outcome = OutcomeConversionService.outcomeConverter(data.o);
    this.outcome = data.o;
    /**
     * Original decimal value of outcome
     */
    this.originalDecimalOutcome = data.o;
    /**
     * Column number (horizontal position)
     * @type {number}
     */
    this.column = data.col;
    /**
     * Order number (vertical position)
     * @type {number}
     */
    this.orderNo = data.ord;
    /**
     * Update class, possible values are 0, 1, -1
     */
    this.upDownClass = typeof data.ud !== 'undefined' ? data.ud : '';
    /**
     * Identifier used for live matches
     * @type {string}
     */
    this.identifier = typeof data.i !== 'undefined' && data.i !== null ? data.i : '';
    /**
     * Specifier used for live matches
     * @type {string}
     */
    this.specifier = typeof data.sp !== 'undefined' && data.sp !== null ? data.sp : '';
    /**
     * Special bet value
     * @type {number}
     */
    this.sbv = data.sbv;
    /**
     * property used for over / under market if there are more than 2 outcomes
     * rule is show first outcome that has active property true
     * if all are inactive, choose first inactive
     * @type {boolean}
     */
    this.active = typeof data.a !== 'undefined' ? data.a : false;
    /**
     * Suspended outcome
     * @type {boolean}
     */
    this.suspended = data.su;
  }
}
